import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import useUserIp from "hooks/useUserIp";

const useBookGeoRestrictions = (bookId, options = {}) => {
	const { accessToken } = useTokenStore();
	const { userIp } = useUserIp();

	const getBookGeoRestrictions = async () => {
		const instance = await InitApi({ accessToken, userIp });
		const response = await instance.get(`/admin/books/${bookId}/geo-restrictions`);
		return response.data;
	};

	return useQuery(["book_geo_restrictions", bookId], getBookGeoRestrictions, {
		enabled: !!bookId,
		staleTime: 5 * 60 * 1000, // 5 minutes
		cacheTime: 10 * 60 * 1000, // 10 minutes
		...options,
	});
};

export default useBookGeoRestrictions;
